export const CV: string[] = [
  'geboren 1964 in Russland',
  '1981 - 1986, Studium an der Militär-Hochschule in Riga (Lettland)',
  '1986 - 1994, Dienst in der Armee auf verschiedenen Komandopositionen',
  '1994 - 2000, Dienst in Spezialeinheiten der Polizei (ähnlich dem deutschen SEK)',
  '2000 - 2008, Stellvertretender Kommandeur der Spezialeinheiten des Zolls (im Rang eines Oberst)',
  '29 Jahre Dienst in Spezialeinheiten der Armee, der Polizei und des Grenzschutzes',
  'vielfach staatlich ausgezeichnet',
];
